import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/airbnb',
    name: 'Airbnb',
    component: () => import('../views/PropertiesForHolidayLet.vue'),
  },
  // Rental Dropdown
  {
    path: '/properties-for-rent',
    name: 'Properties For Rent',
    component: () => import('../views/PropertiesForRent.vue'),
  },
  // {
  //   path: '/properties-for-rent-brisbane',
  //   name: 'Properties For Rent',
  //   component: () => import('../views/PropertiesForRentBrisbane.vue'),
  // },
  {
    path: '/commercial-for-lease',
    name: 'Commercial Properties For Lease',
    component: () => import('../views/PropertiesForRentCommercial.vue'),
  },
  {
    path: '/resources',
    name: 'Tenant Resources',
    component: () => import('../views/Resources.vue'),
  },
  // Tenant Resource Links
  {
    path: '/forms/form-13',
    name: 'Form 13: Notice of Intention to Leave',
    component: () => import('../views/Form13.vue'),
  },
  {
    path: '/forms/maintenance-request',
    name: 'Maintenance Request',
    component: () => import('../views/MaintenanceRequest.vue'),
  },
  {
    path: '/landlord-references',
    name: 'Landlord Referencs',
    component: () => import('../views/LandlordReferences.vue'),
  },
  // Landlord Reference links
  {
    path: '/forms/rental-appraisal',
    name: 'Rental Appraisal',
    component: () => import('../views/RentalAppraisal.vue'),
  },
  {
    path: '/forms/sales-appraisal',
    name: 'Sales Appraisal',
    component: () => import('../views/SalesAppraisal.vue'),
  },
  {
    path: '/forms/property-alerts',
    name: 'Property Alerts',
    component: () => import('../views/PropertyAlerts.vue'),
  },
  // Sales dropdown
  {
    path: '/properties-for-sale',
    name: 'Properties For Sale',
    component: () => import('../views/PropertiesForSale.vue'),
  },
  {
    path: '/commercial-for-sale',
    name: 'Commercial Properties For Sale',
    component: () => import('../views/PropertiesForSaleCommercial.vue'),
  },
  {
    path: '/sold-properties',
    name: 'Sold Properties',
    component: () => import('../views/PropertiesSold.vue'),
  },
  // Property Info
  {
    path: '/property-information',
    name: 'Property Information',
    component: () => import('../views/Blog.vue'),
  },
  {
    path: '/blogs/:id',
    name: 'Blog',
    meta: {
      hide: true,
    },
    component: () => import('../views/BlogDetails.vue'),
  },
  // About us
  {
    path: '/about-us',
    name: 'About us',
    component: () => import('../views/MeetTheTeam.vue'),
  },
  // Contact
  {
    path: '/contact',
    name: 'Contact Us',
    component: () => import('../views/ContactUs.vue'),
  },
  // Other Pages
  {
    path: '/listings/:id',
    name: 'Listing',
    meta: {
      hide: true,
    },
    component: () => import('../views/ListingDetails.vue'),
  },
  // Not being used
  {
    path: '/open-homes',
    name: 'Open Homes',
    component: () => import('../views/InspectionTimes.vue'),
  },
  {
    path: '/request-appraisal',
    name: 'Request Appraisal',
    component: () => import('../views/LeaseAppraisal.vue'),
  },
  {
    path: '/recent-sales',
    name: 'Recent Sales',
    component: () => import('../views/PropertiesSold.vue'),
  },
  {
    path: '/tenant-resources',
    name: 'Tenant Resources',
    component: () => import('../views/Resources.vue'),
  },
  {
    path: '/maintenance-request',
    name: 'Maintenance Request',
    component: () => import('../views/MaintenanceRequest.vue'),
  },
  {
    path: '/vacate-notice',
    name: 'Vacate Notice',
    component: () => import('../views/Form13.vue'),
  },
  {
    path: '/lease-appraisal',
    name: 'Lease Appraisal',
    component: () => import('../views/LeaseAppraisal.vue'),
  },
  {
    path: '/leased',
    name: 'Recently Leased',
    component: () => import('../views/Rented.vue'),
  },
  {
    path: '/property-care',
    name: 'Property Care',
    component: () => import('../views/PropertyCare.vue'),
  },
  {
    path: '/testimonials',
    name: 'Testimonials',
    component: () => import('../views/Testimonials.vue'),
  },
  {
    path: '/calculators',
    name: 'Calculators',
    component: () => import('../views/Calculators.vue'),
  },
  {
    path: '/inspection-times',
    name: 'Inspection Times',
    component: () => import('../views/InspectionTimes.vue'),
  },
  {
    path: '/market-updates',
    name: 'Market Updates',
    component: () => import('../views/MarketUpdates.vue'),
  },
  {
    path: '/properties/last-30-rented',
    name: 'Last 30 Properties Rented',
    component: () => import('../views/Rented.vue'),
  },
  {
    path: '/forms/notice-of-intention-to-leave',
    name: 'Notice of Intention to Leave',
    component: () => import('../views/Form13.vue'),
  },
  {
    path: '/tv-display/sales',
    name: 'TV Display Sales',
    component: () => import('../views/TVDisplaySales.vue'),
    meta: {
      hide: true,
      hideAncillaries: true, // Disables the header and footer
    },
  },
  {
    path: '/tv-display/rentals',
    name: 'TV Display Rentals',
    component: () => import('../views/TVDisplayRentals.vue'),
    meta: {
      hide: true,
      hideAncillaries: true, // Disables the header and footer
    },
  },
  {
    path: '/listings/:id/make-an-offer',
    name: 'Make an Offer',
    meta: {
      hide: true,
    },
    component: () => import('../views/ListingMakeAnOffer.vue'),
  },
  {
    path: '/profiles/:id',
    name: 'Profile',
    meta: {
      hide: true,
    },
    component: () => import('../views/AgentProfile.vue'),
  },
  {
    path: '/profiles/:id/properties',
    name: 'Profile Listings',
    meta: {
      hide: true,
    },
    component: () => import('../views/AgentProfileListings.vue'),
  },
  {
    path: '/profiles/:id/properties/sold',
    name: 'Profile Sold Listings',
    meta: {
      hide: true,
    },
    component: () => import('../views/AgentProfileListingsSold.vue'),
  },
  {
    path: '/profiles/:id',
    name: 'Profile',
    meta: {
      hide: true,
    },
    component: () => import('../views/AgentProfile.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: () => import('../views/Sitemap.vue'),
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: () => import('../views/Unsubscribe.vue'),
  },
  {
    path: '/*',
    name: 'Not Found',
    meta: {
      hide: true,
    },
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
});

export default router;
